/// <amd-module name="Search/WorkItem/Flux/Sources/WorkItemSearchSource" />
import * as Contracts from "Search/LegacyWebApi/Contracts/WorkItem";
import * as Rest_Client from "Search/LegacyWebApi/RestClient/Search";
import { IVssPageContext } from "VSS/Platform/Context";
import { CustomerIntelligenceConstants } from "Search/WorkItem/Constants";
import { IProjectData } from "Tfs/Platform/Page";
import { SearchSourceType, ISearchSourceResponse } from "Search/Shared/Base/Sources/SearchSource";
import { SearchSourceBase } from "Search/Shared/Base/Sources/SearchSource";
import { EntitySearchResponseWithActivityId } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { IVssPageService, IPageData } from "VSS/Platform/Page";

export class WorkItemSearchSource extends SearchSourceBase<Contracts.WorkItemSearchRequest> {
    private workItemSearchRestClient: Rest_Client.ISearchRestClient;
    private pageData: IPageData | undefined;

    constructor(
        private readonly project: IProjectData | undefined,
        private readonly pageContext: IVssPageContext) {
        super(CustomerIntelligenceConstants.QueryResultScenarioName, CustomerIntelligenceConstants.EntityName, pageContext);
        this.workItemSearchRestClient = this.pageContext.getRestClient<Rest_Client.ISearchRestClient>("Legacy.ISearchRestClient");
        this.pageData = this.pageContext.getService<IVssPageService>("IVssPageService").getData();
    }

    public getResults(
        searchQuery: Contracts.WorkItemSearchRequest,
        onSuccess: (response: ISearchSourceResponse) => void,
        onFailure: ({ error, activityId }: any) => void): void {
        this.workItemSearchRestClient
            .postWorkItemQuery(searchQuery, this.project && this.project.id)
            .then(responseWithActivityId => {
                onSuccess({ responseWithActivityId, source: SearchSourceType.RestApi });
            }, error => {
                onFailure({ error, activityId: this.pageData && this.pageData.sessionId });
            });
    }

    public getFacets(
        searchQuery: Contracts.WorkItemSearchRequest,
        onSuccess: (responseWithActivityId: EntitySearchResponseWithActivityId) => void,
        onFailure: () => void): void {
        this.workItemSearchRestClient
            .postWorkItemQuery(searchQuery, this.project && this.project.id)
            .then(responseWithActivityId => {
                onSuccess(responseWithActivityId);
            }, error => {
                onFailure();
            });
    }
}
